class common{

    static injectCSS = function (cssfile) {
        var head = document.head;
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = cssfile;
        head.appendChild(link);
    }

    static isMobile = function () {
        return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i).test(
            navigator.userAgent
        );
    }

    static openUrlInNewTab = function (href) {
        Object.assign(document.createElement('a'), {
            target: '_blank',
            href: href,
        }).click();
    }
    static generateSessionId = function () {
        let array = new Uint32Array(8);
        window.crypto.getRandomValues(array);
        let str = "";
        for (let i = 0; i < array.length; i++) {
          str += (i < 2 || i > 5 ? "" : "-") + array[i].toString(16).slice(-4);
        }
        str = str.replace(/[^a-zA-Z0-9]/g, "");
        str = str.substring(0, 28);
        return str;
      }
}

export default common;